/**
 * 표시 모드 전환 버튼. 모드 목록을 받아 그리므로 화면마다 모드 종류가 달라도 이 컴포넌트는 그대로다
 * (예: 에픽 = 카드/테이블, 나중에 백로그 = 표/그룹, 이슈 = 칸반/타임라인).
 */
export interface ViewModeOption<T extends string> {
  key: T;
  label: string;
  glyph: string;
}

export function ViewModeToggle<T extends string>({
  options,
  value,
  onChange,
}: {
  options: ReadonlyArray<ViewModeOption<T>>;
  value: T;
  onChange: (next: T) => void;
}): React.JSX.Element {
  return (
    <div className="inline-flex overflow-hidden rounded-md border border-line bg-surface" role="group" aria-label="표시 모드">
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          aria-pressed={option.key === value}
          title={`${option.label} 보기`}
          onClick={() => onChange(option.key)}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs not-first:border-l not-first:border-line ${
            option.key === value ? 'bg-accent-soft font-semibold text-accent' : 'text-muted hover:bg-line-soft'
          }`}
        >
          <span aria-hidden>{option.glyph}</span>
          {option.label}
        </button>
      ))}
    </div>
  );
}
